import { mapGettersShorthand } from '@/store/utils/mappers';
import { VIRTUAL_PROJECT_IDS } from '@/utils/projects.const';
import { selectedProjectId } from '@/store/modules/selectedProject/getters.js';
import { MAX_NUM_OF_ITEMS_IN_PREVIEW_CARD } from '@/components/Analytics/analytics.const.js';
import { useRunsByDay, useRunsByUser, useRunsByFeature, useLatestErrors } from '@/store/modules/analytics/getters.js';

export default {
	computed: {
		...mapGettersShorthand({
			selectedProjectId,
			runsByDay: useRunsByDay,
			runsByUser: useRunsByUser,
			latestErrors: useLatestErrors,
			runsByFeature: useRunsByFeature,
		}),
		runsByDayArr() {
			return Object.entries(this.runsByDay).map(([date, runDetails]) => ({ date, ...runDetails }));
		},
		allDays() {
			return Object.keys(this.runsByDay);
		},
		allDaysLinearArr() {
			return this.allDays.map((date) => date);
		},
		allRunsLinearArr() {
			return Object.values(this.runsByDay).map(({ runs }) => runs);
		},
		allRunsAmount() {
			return this.allRunsLinearArr.reduce((a, b) => a + b, 0);
		},
		allErrorsLinearArr() {
			return Object.values(this.runsByDay).map(({ errors }) => errors);
		},
		allErrorsAmount() {
			return this.allErrorsLinearArr.reduce((a, b) => a + b, 0);
		},
		allSuccessRunsPercentageLinearArr() {
			const res = [];
			for (let i = 0; i < this.allDaysLinearArr.length; i++) {
				res[i] = this.getSuccessfulRunsPercentageInSpecificDay(i);
			}
			return res;
		},
		averageSuccessRunsPercentage() {
			if (this.allRunsAmount == 0) {
				return 0;
			}
			const errorRate = (this.allErrorsAmount / this.allRunsAmount) * 100;
			return (100 - errorRate).toFixed(2);
		},
		activeSpaceId() {
			const selectedSpaceId = this.selectedProjectId;
			if (VIRTUAL_PROJECT_IDS.includes(selectedSpaceId)) {
				return null;
			}
			return Number(selectedSpaceId);
		},
	},
	methods: {
		populateTableDataWithCalculatedColumns(tableData) {
			return tableData.map((tableRow) => ({
				...tableRow,
				error_rate: this.getRowErrorRate(tableRow),
				completions: this.getRowCompletions(tableRow),
				completion_rate: this.getRowCompletionRate(tableRow),
			}));
		},
		getRowCompletions(row) {
			return row.runs - row.errors;
		},
		getRowCompletionRate(row) {
			return `${((this.getRowCompletions(row) / row.runs) * 100).toFixed(2)}%`;
		},
		getRowErrorRate(row) {
			return `${((row.errors / row.runs) * 100).toFixed(2)}%`;
		},
		getSuccessfulRunsPercentageInSpecificDay(index) {
			const numOfRunsInThisDay = this.allRunsLinearArr[index];
			const numOfErrorsInThisDay = this.allErrorsLinearArr[index];
			const numOfSuccessRunsInThisDay = numOfRunsInThisDay - numOfErrorsInThisDay;
			return (numOfSuccessRunsInThisDay / numOfRunsInThisDay) * 100 || 0;
		},
	},
	data() {
		return {
			maxNumberOfItemsInPreviewCard: MAX_NUM_OF_ITEMS_IN_PREVIEW_CARD,
		};
	},
};
